import Tasks from 'APP/Tasks';
import Entities from 'STORE';
import { InputPanel } from 'STORE/InputPanelsStore/InputPanel/InputPanel';

export const searchMentions = async (inputPanel: InputPanel, mention: string): Promise<boolean> => {
  try {
    inputPanel.mention.setIsLoading(true);
    inputPanel.mention.setFilter(mention);

    const response = await Tasks.search.searchUsersForMention(inputPanel, mention);

    inputPanel.mention.setMentions(response.users);
    inputPanel.mention.setCursor(response.cursor || null);
    inputPanel.mention.setIsLoading(false);
    Entities.usersStore.add(response.users);

    return true;
  } catch {
    inputPanel.mention.reset();

    return false;
  }
};
